
export interface IMenuItem {
	name: string,
	uri: string,
	isCurrent: boolean,
	id: string,
	isExpanded: boolean,
	hasChildren: boolean,
	children: IMenuItem[],
	level: number
}
export interface IMenu {
	menuItems: IMenuItem[]
}
export interface ITranslations {
	mainMenu: string,
	openMenu: string,
	closeMenu: string
}
export interface IExtraLink {
	url: string
}
export interface ITopLinks {
	displayName: string,
	uri: string,
	url: string
}
export interface ICampaignWeb {
	campaignWeb: string,
}

export interface IState {
	menuItems: IMenuItem[]
	apiURLs: {
		getChildren: string
	},
	translations: ITranslations,
	extraLinks: string,
	className: string,
	topLinks: ITopLinks[],
	campaignWeb: string
}

const deafultState: IState = {	
	menuItems: [],	
	apiURLs: {
		getChildren: ''
	},
	translations: {
		mainMenu: '',
		openMenu: '',
		closeMenu: ''
	},
	extraLinks: '',
	className: '',
	topLinks: [],
	campaignWeb: ''
}

export default deafultState;